import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import Templates from 'views/admin/EmailTemplates/Templates'

const EmailTemplates = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <Templates />
      </Route>
    </Switch>
  )
}

export default EmailTemplates
